<template>
  <div class="">
    <div class="graph_title no-select">
      炭素行业产业链全景图谱
    </div>
    <div class="screen_full">
      <el-tooltip placement="bottom" :content="isFullscreen ? '退出全屏' : '切为全屏'">
        <div @click="click">
          <svg v-if="!isFullscreen" t="1744160619985" class="icon" viewBox="0 0 1024 1024" version="1.1"
            xmlns="http://www.w3.org/2000/svg" p-id="1490" width="25" height="25">
            <path
              d="M290 236.4l43.9-43.9c4.7-4.7 1.9-12.8-4.7-13.6L169 160c-5.1-0.6-9.5 3.7-8.9 8.9L179 329.1c0.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L370 423.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L290 236.4zM642.7 423.7c3.1 3.1 8.2 3.1 11.3 0l133.7-133.6 43.7 43.7c4.7 4.7 12.8 1.9 13.6-4.7L863.9 169c0.6-5.1-3.7-9.5-8.9-8.9L694.8 179c-6.6 0.8-9.4 8.9-4.7 13.6l43.9 43.9L600.3 370c-3.1 3.1-3.1 8.2 0 11.3l42.4 42.4zM845 694.9c-0.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L654 600.3c-3.1-3.1-8.2-3.1-11.3 0l-42.4 42.3c-3.1 3.1-3.1 8.2 0 11.3L734 787.6l-43.9 43.9c-4.7 4.7-1.9 12.8 4.7 13.6L855 864c5.1 0.6 9.5-3.7 8.9-8.9L845 694.9zM381.3 600.3c-3.1-3.1-8.2-3.1-11.3 0L236.3 733.9l-43.7-43.7c-4.7-4.7-12.8-1.9-13.6 4.7L160.1 855c-0.6 5.1 3.7 9.5 8.9 8.9L329.2 845c6.6-0.8 9.4-8.9 4.7-13.6L290 787.6 423.7 654c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.4z"
              p-id="1491" fill="#ffffff"></path>
          </svg>
          <svg v-else t="1744160697474" class="icon" viewBox="0 0 1024 1024" version="1.1"
            xmlns="http://www.w3.org/2000/svg" p-id="1700" width="25" height="25">
            <path
              d="M391 240.9c-0.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L200 146.3c-3.1-3.1-8.2-3.1-11.3 0l-42.4 42.3c-3.1 3.1-3.1 8.2 0 11.3L280 333.6l-43.9 43.9c-4.7 4.7-1.9 12.8 4.7 13.6L401 410c5.1 0.6 9.5-3.7 8.9-8.9L391 240.9zM401.1 614.1L240.8 633c-6.6 0.8-9.4 8.9-4.7 13.6l43.9 43.9L146.3 824c-3.1 3.1-3.1 8.2 0 11.3l42.4 42.3c3.1 3.1 8.2 3.1 11.3 0L333.7 744l43.7 43.7c4.7 4.7 12.8 1.9 13.6-4.7l18.9-160.1c0.6-5.1-3.7-9.4-8.8-8.8zM622.9 409.9L783.2 391c6.6-0.8 9.4-8.9 4.7-13.6L744 333.6 877.7 200c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.3c-3.1-3.1-8.2-3.1-11.3 0L690.3 279.9l-43.7-43.7c-4.7-4.7-12.8-1.9-13.6 4.7L614.1 401c-0.6 5.2 3.7 9.5 8.8 8.9zM744 690.4l43.9-43.9c4.7-4.7 1.9-12.8-4.7-13.6L623 614c-5.1-0.6-9.5 3.7-8.9 8.9L633 783.1c0.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L824 877.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L744 690.4z"
              p-id="1701" fill="#ffffff"></path>
          </svg>
        </div>
      </el-tooltip>
    </div>
    <div class="graph_sign flex color_fff no-select">
      <div class="flex"><img src="@/assets/images/chartTypeBg.png" alt="" /> 燃料级</div>
      <div class="flex"><img src="@/assets/images/chartTypeBg2.png" alt="" /> 碳素级</div>
    </div>
    <div class="operating_instructions_btn cursor" @click="isOperatinginstructions = false">操作指引</div>
    <div class="graph_main flex_center">
      <!-- animate-scale-two -->
      <div class="graph_left" ref="graphContainer">
        <!-- <img class="chart_img" src="@/assets/images/chartImg.png" alt="" /> -->
        <RelationGraph ref="graphRef" :options="graphOptions" :on-node-click="onNodeClick">
          <template #line="{ line, link }">
            <svg width="0" height="0">
              <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" style="stop-color:#00a5fa; stop-opacity: 1" />
                <stop offset="100%" style="stop-color:#2241f9; stop-opacity: 1" />
              </linearGradient>
              <linearGradient id="lineGradientTwo" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" style="stop-color:#37ffef ; stop-opacity: 1" />
                <stop offset="100%" style="stop-color:#00a5fa; stop-opacity: 1" />
              </linearGradient>

              <linearGradient id="lineGradientThree" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" style="stop-color:#2241f9; stop-opacity: 1" />
                <stop offset="100%" style="stop-color:#00a5fa; stop-opacity: 1" />
              </linearGradient>
              <linearGradient id="lineGradientFour" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" style="stop-color:#00a5fa; stop-opacity: 1" />
                <stop offset="100%" style="stop-color:#37ffef; stop-opacity: 1" />
              </linearGradient>
              <!-- 定义箭头标记 -->
              <marker id="arrow" viewBox="0 0 10 10" refX="10" refY="5" markerWidth="6" markerHeight="6"
                orient="auto-start-reverse">
                <path d="M10 0 L0 5 L10 10 z" fill="rgba(34, 65, 249, 1)" />
              </marker>

              <marker id="arrowTwo" viewBox="0 0 10 10" refX="10" refY="5" markerWidth="6" markerHeight="6"
                orient="auto-start-reverse">
                <path d="M10 0 L0 5 L10 10 z" fill="#ff9537" />
              </marker>
            </svg>
            <g @click="onLineClick(line, link, $event)" class="cursor pd10 "
              :class="{ 'fade-out': hideSeeksIdList.includes(link.seeks_id), 'fade-in': showSeeksIdsTwo.includes(link.seeks_id), 'display_none': line.opacity == '0' }">
              <path :d="pathData(link)" :stroke="showSeeksIds.includes(link.seeks_id) ? '' : 'rgba(255, 255, 255, 0)'"
                stroke-width="8" fill="none" />

              <!-- 绘制第一段线 -->
              <!-- 起点石油焦节点以及其子节点的线 -->
              <path :d="pathDataOne(link, 1)"
                v-if="Number(link.fromNode.id) < 95 && Number(link.fromNode.id) != 85 && Number(link.fromNode.id) != 83 || Number(link.fromNode.id) == 101 || Number(link.toNode.id) == 102 || Number(link.toNode.id) == 97"
                :stroke="showSeeksIds.includes(link.seeks_id) ? '#ff9537' : 'url(#lineGradient)'" stroke-width="2"
                fill="none" />
              <!-- 起点炼油厂节点的线 -->
              <path :d="pathDataOne(link, 2)" v-if="Number(link.fromNode.id) == 85"
                :stroke="showSeeksIds.includes(link.seeks_id) ? '#ff9537' : 'url(#lineGradientThree)'" stroke-width="2"
                fill="none" stroke-dasharray="10 5" stroke-dashoffset="135" />
              <!-- 起点煅烧焦节点以及其子节点的线 -->
              <path :d="pathDataOne(link, 3)"
                v-if="Number(link.fromNode.id) >= 95 && Number(link.toNode.id) != 102 && Number(link.toNode.id) != 97 && Number(link.fromNode.id) != 101 || Number(link.fromNode.id) == 83"
                :stroke="showSeeksIds.includes(link.seeks_id) ? '#ff9537' : 'url(#lineGradientThree)'" stroke-width="2"
                fill="none" />
              <!-- 绘制第二段线 -->
              <!-- 起点石油焦节点以及其子节点的线 -->
              <path :d="pathDataTwo(link, 1)"
                v-if="Number(link.fromNode.id) < 95 && Number(link.fromNode.id) != 85 && Number(link.fromNode.id) != 83 || Number(link.toNode.id) == 102 || Number(link.toNode.id) == 97 || Number(link.fromNode.id) == 101"
                :stroke="showSeeksIds.includes(link.seeks_id) ? '#ff9537' : 'url(#lineGradientTwo)'" stroke-width="2"
                fill="none" :marker-start="showSeeksIds.includes(link.seeks_id) ? 'url(#arrowTwo)' : 'url(#arrow)'" />
              <!-- 起点炼油厂节点的线 -->
              <path :d="pathDataTwo(link, 2)" v-if="Number(link.fromNode.id) == 85"
                :stroke="showSeeksIds.includes(link.seeks_id) ? '#ff9537' : 'url(#lineGradientFour)'" stroke-width="2"
                fill="none" :marker-start="showSeeksIds.includes(link.seeks_id) ? 'url(#arrowTwo)' : 'url(#arrow)'"
                stroke-dasharray="10 5" stroke-dashoffset="135" />
              <!-- 起点煅烧焦节点以及其子节点的线 -->
              <path :d="pathDataTwo(link, 3)"
                v-if="Number(link.fromNode.id) >= 95 && Number(link.toNode.id) != 102 && Number(link.toNode.id) != 97 && Number(link.fromNode.id) != 101 || Number(link.fromNode.id) == 83"
                :stroke="showSeeksIds.includes(link.seeks_id) ? '#ff9537' : 'url(#lineGradientFour)'" stroke-width="2"
                fill="none" :marker-start="showSeeksIds.includes(link.seeks_id) ? 'url(#arrowTwo)' : 'url(#arrow)'" />
            </g>
          </template>
          <template #node="{ node }">
            <div class="node_box_two" :style="{ backgroundImage: 'url(' + node.data.backgroundImage + ')', }"
              v-if="node.id == 114"></div>
            <div class="node_box cursor" @mouseenter="graphEnter(node.id)" @mouseleave="chartLeave"
              :class="{ 'fade-out': hideSelectIdList.includes(node.id), 'fade-in': showSelectId.includes(node.id), 'animate-scale-one': chartId == node.id, 'border_color': selectNideId == node.id }"
              v-else
              :style="{ height: node.height + 'px', width: node.width + 'px', fontSize: node.data.fontSize + 'px', color: node.data.fontColor, backgroundImage: 'url(' + node.data.backgroundImage + ')', }">
              <!-- <img class="no-select"
                :style="{ width: node.width / 3 + 'px', height: node.width / 3 + 'px,object-fit: contain' }"
                :src="node.data.logo" alt="" /> -->
              <span style="color: rgba(255, 255, 255, 0);">{{ node.text }}</span>
              <span v-if="Number(node.id) > 95 && Number(node.id) <= 102" class="node_num_three">{{
                node.data.industryCount }}</span>
              <span v-else :class="node.id == '82' || node.id == '95' ? 'node_num_two' : 'node_num'">{{
                node.data.industryCount }}</span>
            </div>
          </template>
        </RelationGraph>
      </div>

      <div class="graph_right" v-if="rightEnterpriseList.length > 0"
        :class="rightEnterpriseList.length > 0 ? 'fade-in' : 'fade-out'">
        <div class="graph_right_title flex_between">
          <div></div> {{ diagramIdName }}({{ rightEnterpriseList.length }}家) <div class="close_icon"
            @click="rightEnterpriseList = []">
            <el-icon>
              <CloseBold />
            </el-icon>
          </div>
        </div>
        <div class="graph_right_top_box flex_around color_fff">
          <div class="box_one flex_center">序号</div>
          <div class="box_two flex_center">企业名称</div>
          <div class="box_three flex_center">资质类别</div>
          <div class="box_four flex_center">区域</div>
        </div>
        <div class="graph_right_data_list color_fff">
          <div class="graph_right_data_box flex_around" v-for="(item, index) in rightEnterpriseList"
            :key="item.productId">
            <div class="box_one flex_center">{{ index + 1 }}</div>
            <div class="box_two flex_center">{{ item.clientName }}</div>
            <div class="box_three flex_center">
              <marquee loop="infinite" behavior="scroll" scrollamount="3">{{ item.qualificationType }}</marquee>
            </div>
            <div class="box_four flex_center">{{ item.detail }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="operating_instructions_mask" v-if="!isOperatinginstructions" @click="closeOperatinginstructions">
    </div>
    <div class="operating_instructions_box" v-if="!isOperatinginstructions">
      <div class="flex_end cursor" @click="closeOperatinginstructions">
        <img src="@/assets/images/guideIcon1.png" alt="" />
      </div>
      <div class="operating_title">
        <img src="@/assets/images/guideIcon2.png" alt="">
      </div>
      <div class="operating_text_one">
        本界面采用交互式节点连线设计，为您提供灵活便捷的信息浏览体验，具体操作方式如下:
      </div>
      <div class="flex mt20">
        <div class="operating_text_two">
          <div class="guide_icon3"><img src="@/assets/images/guideIcon3.png" alt="" /></div>
          1.内容收展操作:点击节点之间的连线，即可快速收起关联节点的内容，让界面更加简洁清晰。若需重新查看，只需点击对应的父级节点，收起的内容便会立即恢复展示。
        </div>
        <div class="guide_img1">
          <img class="" src="@/assets/images/guideImg1.gif" alt="" />
        </div>

      </div>
      <div class="operating_text_two mt20">2.信息查询操作:轻点任意节点，即可即刻呈现与当前节点相关的企业详细信息。</div>
      <div class="guide_img2">
        <img src="@/assets/images/guideImg2.gif" alt="" />
      </div>
      <div class="operating_text_three">通过这两种交互方式，您可轻松实现对产业图谱的灵活管理与深度探索。</div>
    </div>
  </div>
</template>
<script setup>
import { ref, reactive, onMounted, getCurrentInstance, nextTick } from "vue"
import screenfull from 'screenfull'
import RelationGraph from 'relation-graph-vue3';
onMounted(() => {
  window.addEventListener('resize', handleResize);
  // 组件挂载后执行的代码
  getBasicInfo();

});

const isOperatinginstructions = ref(true);

// const openOperatinginstructions = () => {
//   isOperatinginstructions.value = false;
// }

const closeOperatinginstructions = () => {
  isOperatinginstructions.value = true;
  let userList = JSON.parse(localStorage.isOperatinginstructions);
  // 使用 findIndex 方法查找匹配项的索引
  let resultIndex = userList.findIndex(item => item.userId === localStorage.userId);

  userList[resultIndex].isOperatinginstructions=isOperatinginstructions.value;
  localStorage.isOperatinginstructions =  JSON.stringify(userList);
}

const graphContainer = ref(null);

const handleResize = () => {

  if (graphContainer.value) {
    const width = graphContainer.value.clientWidth;
    const height = graphContainer.value.clientHeight;
    const graphInstance = graphRef.value.getInstance();
    graphRef.value.getInstance().resetViewSize(width, height); // 这是调整大小的方法名
    // graphInstance.refresh();
    graphInstance.moveToCenter();
    graphInstance.zoomToFit();
    graphInstance.setZoom(77)
  }
};
let isFullscreen = ref(false)
const { proxy } = getCurrentInstance();

import { diagramList, diagramRightList } from "@/utils/homeApi";

const diagramId = ref(null);
const diagramIdName = ref(null);

const detail = ref(null);
const rightEnterpriseList = ref([]);
const getDiagramRightList = async () => {
  let res = await diagramRightList({
    diagramId: diagramId.value,
    detail: detail.value
  });
  if (res.code == 200) {
    rightEnterpriseList.value = res.data;
  }
  // proxy.$message({
  //   message: '这是一条全局配置后的消息',
  //   type: 'success'
  // });
};

const graphRef = ref(null);
const listDiagramInfo = ref(null);
const graphOptions = ref({
  // 这里可以参考"Graph 图谱"中的参数进行设置
  "allowShowMiniToolBar": false,
  "disableZoom": true,
  "disableDragCanvas": true,
  isMoveByParentNode: true,
  zoomToFitWhenRefresh: true,
  "defaultFocusRootNode": false, //禁用默认选中根节点
  "disableNodeClickEffect": true, //禁用节点选中效果
  backgroundColor: "rgba(255, 255, 255, 0)",
  layout: {
    "layoutName": "force",
    "distance_coefficient": 1,
    "maxLayoutTimes": 100000,
    "force_node_repulsion": 0.21,
    "force_line_elastic": 1.3
  },
});

// 首页基本信息列表
const getBasicInfo = async () => {
  let res4 = await diagramList();
  if (res4.code == 200) {
    listDiagramInfo.value = res4.data;
    showGraph();

    if (!localStorage.isOperatinginstructions) {
      isOperatinginstructions.value = false;
      localStorage.isOperatinginstructions = JSON.stringify([{
        userId: localStorage.userId,
        isOperatinginstructions: isOperatinginstructions.value
      }]);
    } else {
      let userList = JSON.parse(localStorage.isOperatinginstructions);
      // 使用 findIndex 方法查找匹配项的索引
      let resultIndex = userList.findIndex(item => item.userId === localStorage.userId);

      if (resultIndex >= 0) {
        isOperatinginstructions.value = userList[resultIndex].isOperatinginstructions;
      } else {
        isOperatinginstructions.value = false;
        userList.push({
          userId: localStorage.userId,
          isOperatinginstructions: isOperatinginstructions.value
        })
        localStorage.isOperatinginstructions = JSON.stringify(userList);
      }
    }
  }
};
const click = () => {
  if (!screenfull.isEnabled) {
    return false
  }

  isFullscreen = !isFullscreen;
  screenfull.toggle();
  // getBasicInfo();
}
const showGraph = () => {
  const __graph_json_data = {
    rootId: "82",
    nodes: listDiagramInfo.value.nodes,
    lines: listDiagramInfo.value.lines
  };
  const graphInstance = graphRef.value.getInstance();
  graphInstance.setJsonData(__graph_json_data).then(() => {
    graphInstance.moveToCenter();
    graphInstance.zoomToFit();
    graphInstance.setZoom(77)
  });
};

const hideSelectId = ref(null);
const hideSeeksId = ref(null);
const showSelectId = ref([]);
// 节点连线颜色的切换
const showSeeksIds = ref([]);
//节点连线逐渐显示数组
const showSeeksIdsTwo = ref([]);

const pathData = (link) => {
  const fx = link.fromNode.x + 50;
  const fy = link.fromNode.y + 40;
  const tx = link.toNode.x + 50;
  const ty = link.toNode.y + 50;
  return 'M ' + fx + ' ' + fy + ' L ' + (tx) + ' ' + (ty);
}

const pathDataOne = (link, type) => {
  if (link.fromNode.id == '82') {
    const fx = link.fromNode.x + 100;
    const fy = link.fromNode.y + 100;
    const tx = link.toNode.x + 60;
    const ty = link.toNode.y + 60;
    const midX = (fx + tx) / 2;
    const midY = (fy + ty) / 2;
    return 'M ' + fx + ' ' + fy + ' L ' + (midX) + ' ' + (midY);
  } else if (link.fromNode.id == '95') {
    if (link.toNode.id == '96') {
      const fx = link.fromNode.x + 100;
      const fy = link.fromNode.y + 100;
      const tx = link.toNode.x + 60;
      const ty = link.toNode.y + 80;
      const midX = (fx + tx) / 2;
      const midY = (fy + ty) / 2;
      return 'M ' + fx + ' ' + fy + ' L ' + (midX) + ' ' + (midY);
    }
    const fx = link.fromNode.x + 100;
    const fy = link.fromNode.y + 100;
    const tx = link.toNode.x + 60;
    const ty = link.toNode.y + 60;
    const midX = (fx + tx) / 2;
    const midY = (fy + ty) / 2;
    return 'M ' + fx + ' ' + fy + ' L ' + (midX) + ' ' + (midY);
  } else if (link.fromNode.id == '85') {
    const fx = link.fromNode.x + 60;
    const fy = link.fromNode.y + 60;
    const tx = link.toNode.x + 100;
    const ty = link.toNode.y + 100;
    const midX = (fx + tx) / 2;
    const midY = (fy + ty) / 2;
    return 'M ' + fx + ' ' + fy + ' L ' + (midX) + ' ' + (midY);
  } else if (link.fromNode.id == '96') {
    const fx = link.fromNode.x + 80;
    const fy = link.fromNode.y + 70;
    const tx = link.toNode.x + 50;
    const ty = link.toNode.y + 40;
    const midX = (fx + tx) / 2;
    const midY = (fy + ty) / 2;
    return 'M ' + fx + ' ' + fy + ' L ' + (midX) + ' ' + (midY);
  } else if (link.fromNode.id == '98') {
    const fx = link.fromNode.x + 80;
    const fy = link.fromNode.y + 70;
    const tx = link.toNode.x + 50;
    const ty = link.toNode.y + 40;
    const midX = (fx + tx) / 2;
    const midY = (fy + ty) / 2;
    return 'M ' + fx + ' ' + fy + ' L ' + (midX) + ' ' + (midY);
  } else if (link.fromNode.id == '101') {
    const fx = link.fromNode.x + 50;
    const fy = link.fromNode.y + 60;
    const tx = link.toNode.x + 50;
    const ty = link.toNode.y + 40;
    const midX = (fx + tx) / 2;
    const midY = (fy + ty) / 2;
    return 'M ' + fx + ' ' + fy + ' L ' + (midX) + ' ' + (midY);
  } else {
    const fx = link.fromNode.x + 50;
    const fy = link.fromNode.y + 40;
    const tx = link.toNode.x + 50;
    const ty = link.toNode.y + 40;
    const midX = (fx + tx) / 2;
    const midY = (fy + ty) / 2;
    return 'M ' + fx + ' ' + fy + ' L ' + (midX) + ' ' + (midY);
  }
}

const pathDataTwo = (link) => {
  if (link.fromNode.id == '82') {
    const fx = link.fromNode.x + 100;
    const fy = link.fromNode.y + 100;
    const tx = link.toNode.x + 60;
    const ty = link.toNode.y + 60;
    const midX = (fx + tx) / 2;
    const midY = (fy + ty) / 2;
    return 'M ' + midX + ' ' + midY + ' L ' + (tx) + ' ' + (ty);
  } else if (link.fromNode.id == '95') {
    if (link.toNode.id == '96') {
      const fx = link.fromNode.x + 100;
      const fy = link.fromNode.y + 100;
      const tx = link.toNode.x + 60;
      const ty = link.toNode.y + 80;
      const midX = (fx + tx) / 2;
      const midY = (fy + ty) / 2;
      return 'M ' + midX + ' ' + midY + ' L ' + (tx) + ' ' + (ty);
    }
    const fx = link.fromNode.x + 100;
    const fy = link.fromNode.y + 100;
    const tx = link.toNode.x + 60;
    const ty = link.toNode.y + 60;
    const midX = (fx + tx) / 2;
    const midY = (fy + ty) / 2;
    return 'M ' + midX + ' ' + midY + ' L ' + (tx) + ' ' + (ty);
  } else if (link.fromNode.id == '85') {
    const fx = link.fromNode.x + 60;
    const fy = link.fromNode.y + 60;
    const tx = link.toNode.x + 100;
    const ty = link.toNode.y + 100;
    const midX = (fx + tx) / 2;
    const midY = (fy + ty) / 2;
    return 'M ' + midX + ' ' + midY + ' L ' + (tx) + ' ' + (ty);
  } else if (link.fromNode.id == '96') {
    const fx = link.fromNode.x + 80;
    const fy = link.fromNode.y + 70;
    const tx = link.toNode.x + 50;
    const ty = link.toNode.y + 40;
    const midX = (fx + tx) / 2;
    const midY = (fy + ty) / 2;
    return 'M ' + midX + ' ' + midY + ' L ' + (tx) + ' ' + (ty);
  } else if (link.fromNode.id == '98') {
    const fx = link.fromNode.x + 80;
    const fy = link.fromNode.y + 70;
    const tx = link.toNode.x + 50;
    const ty = link.toNode.y + 40;
    const midX = (fx + tx) / 2;
    const midY = (fy + ty) / 2;
    return 'M ' + midX + ' ' + midY + ' L ' + (tx) + ' ' + (ty);
  } else if (link.fromNode.id == '101') {
    const fx = link.fromNode.x + 50;
    const fy = link.fromNode.y + 60;
    const tx = link.toNode.x + 50;
    const ty = link.toNode.y + 40;
    const midX = (fx + tx) / 2;
    const midY = (fy + ty) / 2;
    return 'M ' + midX + ' ' + midY + ' L ' + (tx) + ' ' + (ty);
  } else {
    const fx = link.fromNode.x + 50;
    const fy = link.fromNode.y + 40;
    const tx = link.toNode.x + 50;
    const ty = link.toNode.y + 40;
    const midX = (fx + tx) / 2;
    const midY = (fy + ty) / 2;
    return 'M ' + midX + ' ' + midY + ' L ' + (tx) + ' ' + (ty);
  }
}


const chartId = ref(null);

const graphEnter = (type) => {
  chartId.value = type;
};
const chartLeave = () => {
  chartId.value = null;
};

const selectNideId = ref(null);

const onNodeClick = (nodeObject, $event) => {
  console.log('onNodeClick:', nodeObject);
  selectNideId.value = nodeObject.id;
  showSelectId.value = [];
  showSeeksIds.value = [];

  hideSelectIdList.value = [];
  hideSeeksIdList.value = [];
  showSeeksIdsTwo.value = [];
  let childrenNode = nodeObject.targetTo;
  // 切换父节点的展开状态
  childrenNode.forEach(ele => {
    if (ele.isHide) {
      showSelectId.value.push(ele.id);
      let seeks_id = nodeObject.seeks_id + '-' + ele.seeks_id;
      showSeeksIdsTwo.value.push(seeks_id)
      ele.isHide = false;
      showobtainChildNode(ele.targetTo, ele.seeks_id);
    }
  });

  diagramIdName.value = nodeObject.text
  diagramId.value = nodeObject.id;

  getDiagramRightList();
  if (nodeObject.id == '82' || nodeObject.id == '95') {
    return
  }
  // obtainSeeksId(nodeObject.targetTo, nodeObject.seeks_id);
  obtainSeeksIdTwo(nodeObject.targetFrom, nodeObject.seeks_id);
};

// 获取与子节点之间的连线
// const obtainSeeksId = (targetTo, id) => {
//   if (targetTo.length == 0) {
//     return
//   }
//   targetTo.forEach((ele) => {
//     let seeks_id = id + '-' + ele.seeks_id;
//     showSeeksIds.value.push(seeks_id)
//     obtainSeeksId(ele.targetTo, ele.seeks_id)
//   })
// };

// 获取与父节点之间的连线
const obtainSeeksIdTwo = (targetFrom, id) => {
  if (targetFrom.length == 0) {
    return
  }

  if (targetFrom[0].id == '82' || targetFrom[0].id == '95') {
    let seeks_id = targetFrom[0].seeks_id + '-' + id;
    showSeeksIds.value.push(seeks_id)
    return
  }

  let seeks_id = targetFrom[0].seeks_id + '-' + id;
  showSeeksIds.value.push(seeks_id)
  // targetFrom[0].targetTo.forEach((ele) => {
  //   let seeks_id = targetFrom[0].seeks_id + '-' + ele.seeks_id;
  //   showSeeksIds.value.push(seeks_id)
  // })
  obtainSeeksIdTwo(targetFrom[0].targetFrom, targetFrom[0].seeks_id)
};

// 展示子节点之间的连线
const showobtainChildNode = (targetTo, id) => {
  if (targetTo.length == 0) {
    return
  }
  targetTo.forEach((ele) => {
    let seeks_id = id + '-' + ele.seeks_id;
    showSeeksIdsTwo.value.push(seeks_id)
    showSelectId.value.push(ele.id);
    ele.isHide = !ele.isHide;
    showobtainChildNode(ele.targetTo, ele.seeks_id)
  })
};

const hideSelectIdList = ref([]);
const hideSeeksIdList = ref([]);

const onLineClick = (lineObject, linkObject, $event) => {
  console.log('onLineClick:', linkObject);
  showSelectId.value = [];
  hideSelectIdList.value = [];
  hideSeeksIdList.value = [];
  showSeeksIdsTwo.value = [];
  if (linkObject.fromNode.id == 85) {
    return
  }
  // 假设连线连接的节点是父节点（可根据实际数据结构调整）
  const parentNode = linkObject.toNode;
  hideSelectId.value = parentNode.id;
  hideSeeksId.value = linkObject.seeks_id;

  hideSelectIdList.value.push(parentNode.id);
  hideSeeksIdList.value.push(linkObject.seeks_id);
  obtainChildNode(parentNode.targetTo, parentNode.seeks_id);
  // 切换父节点的展开状态
  setTimeout(() => {
    parentNode.isHide = !parentNode.isHide;
    hideSelectId.value = null;
    hideobtainChildNode(parentNode.targetTo, linkObject.seeks_id);
  }, 1000)
  // 更新图表
  // graphRef.updateView();
};


// 获取与子节点之间的连线
const obtainChildNode = (targetTo, id) => {
  if (targetTo.length == 0) {
    return
  }
  targetTo.forEach((ele) => {
    let seeks_id = id + '-' + ele.seeks_id;
    hideSelectIdList.value.push(ele.id);
    hideSeeksIdList.value.push(seeks_id);
    obtainChildNode(ele.targetTo, ele.seeks_id)
  })
};

// 隐藏子节点之间的连线
const hideobtainChildNode = (targetTo, id) => {
  if (targetTo.length == 0) {
    return
  }
  targetTo.forEach((ele) => {
    // let seeks_id = id + '-' + ele.seeks_id;
    // showSeeksIds.value.push(seeks_id)
    ele.isHide = !ele.isHide;
    hideobtainChildNode(ele.targetTo, ele.seeks_id)
  })
};

</script>
<style lang="scss" scoped>
.graph_title {
  position: fixed;
  padding-top: 15px;
  width: 100%;
  font-weight: 400;
  font-family: youshebiaotihei;
  font-size: 50px;
  letter-spacing: 5px;
  color: white;
  text-align: center;
}

.graph_sign {
  position: absolute;
  top: 20vh;
  left: 20vh;

  img {
    width: 40px;
    height: 40px;
    margin-left: 20px;
    margin-right: 5px;
  }
}

.operating_instructions_btn {
  position: absolute;
  top: 20.5vh;
  left: 45vh;
  z-index: 8;
  padding: 5px 15px;
  color: #fff;
  background-color: #284187;
  border-radius: 3px;
  margin-left: 20px;
}

.graph_main {
  width: 100%;
  background: url('@/assets/images/chartBg.jpg') center no-repeat;
  background-size: 100% 100%;
  height: 85vh;
  padding: 12vh 0 3vh 0;
}

.graph_left {
  position: relative;
  height: 100%;
  width: 75%;
}

.pd10 {
  padding: 10px;
}

.chart_img {
  position: absolute;
  top: 43vh;
  left: 48vh;
  z-index: 9;
  width: 60px;
}

.graph_right {
  position: relative;
  z-index: 19;
  // right: 200px;
  width: 20%;
  height: 70vh;
  margin-left: -15%;
  background: url('@/assets/images/panoramicMapRightBg.png') center no-repeat;
  background-size: 100% 100%;
}

.graph_right_title {
  padding: 35px 35px 0 70px;
  color: #fff;
  font-size: 30px;
  margin-bottom: 30px;
  font-family: youshebiaotihei;
  letter-spacing: 0.05vw;
  color: white;
  text-align: center;
  background: linear-gradient(0deg, #E6FCFF 0%, #B2E6FC 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.close_icon {
  font-size: 20px;
}

.graph_right_top_box {
  width: 75%;
  background: url('@/assets/images/mapDataBg1.png') center no-repeat;
  background-size: 100% 100%;
  margin: 0 auto;
  margin-bottom: 10px;
  padding: 5px 10px;
}

.box_one {
  width: 40px;
}

.box_two {
  width: 80px;
}

.box_three {
  width: 70px;
}

.box_four {
  width: 80px;
}

.graph_right_data_list {
  height: 52vh;
  overflow-y: auto;

  &::-webkit-scrollbar {
    display: none; // 滚动条隐藏
  }
}

.graph_right_data_box {
  width: 75%;
  background: url('@/assets/images/mapDataBg2.png') center no-repeat;
  background-size: 100% 100%;
  margin: 0 auto;
  margin-bottom: 10px;
  padding: 5px 10px;
  font-size: 13px;
}

.node_box {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
  font-family: Alibaba-PuHuiTi-B;
  font-weight: 500
}

.node_num {
  padding-bottom: 5%;
}

.node_num_two {
  padding-bottom: 17%;
}

.node_num_three {
  padding-bottom: 10%;
}

.node_box_two {
  width: 100%;
  height: 100%;
  background: no-repeat;
  background-position: no-repeat;
}

.animate-scale-one {
  animation: scaleAnimation_one 1s infinite alternate;
}

@keyframes scaleAnimation_one {
  from {
    transform: scale(1);
  }

  to {
    transform: scale(1.1);
  }
}

.animate-scale-two {
  animation: scaleAnimation_two 2s infinite alternate;
}

@keyframes scaleAnimation_two {
  from {
    transform: scale(1);
  }

  to {
    transform: scale(1.02);
  }
}

@keyframes fadeOutAnimation {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

.fade-out {
  animation: fadeOutAnimation 1s;
}

@keyframes fadeInAnimation {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.fade-in {
  animation: fadeInAnimation 2s;
}

.border_color {
  filter: drop-shadow(0px 0px 7px #43DAFF);
}

.no-select {
  user-select: none;
  /* 禁止文本选择 */
  pointer-events: none;
  /* 禁止鼠标事件（无法点击、拖动等） */
  -webkit-user-drag: none;
  /* 禁止 WebKit 浏览器拖动 */
  cursor: default;
  /* 更改鼠标样式，避免误导 */
}

.operating_instructions_mask {
  position: fixed;
  z-index: 9;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(51, 51, 51, 0.4);
}

.operating_instructions_box {
  position: fixed;
  z-index: 10;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 610px;
  // height: 600px;
  background-color: #fff;
  border-radius: 10px;
  background: url("../../assets/images/guideBg.png") no-repeat center;
  background-size: 100% 100%;
  padding: 30px 40px;
  color: #a7e6e9;

}

.operating_title {
  width: 100%;
}

.operating_text_one {
  font-family: SOURCEHANSANSCN-M;
  font-size: 18px;
}

.operating_text_two {
  display: flex;
  font-size: 14px;
  font-family: SOURCEHANSANSCN-L;
  font-weight: 400;
  line-height: 25px;
  letter-spacing: 2px;
}

.operating_text_three {
  width: 100%;
  font-size: 15px;
  font-family: SOURCEHANSANSCN-R;
  text-align: center;
  letter-spacing: 2px;
}

.guide_icon3 {
  margin-right: 15px;
}

.guide_img1 {
  padding: 10px 10px 5px 10px;
  margin-right: 40px;
  background: url("../../assets//images/guideBg2.png") no-repeat center;
  background-size: 100% 100%;
  margin-left: 50px;

  img {
    height: 150px;
    height: 100px;
  }
}

.guide_img2 {
  display: block;
  width: 360px;
  padding: 10px 10px 5px 10px;
  margin: 10px auto;
  background: url("../../assets//images/guideBg3.png") no-repeat center;
  background-size: 100% 100%;

  img {
    width: 360px;
    // height: 130px;
  }
}
</style>
